import React from "react";
import { useTranslation } from 'react-i18next';
import About from "../Components/about/About";
import Contact from "../Components/contact/Contact";
import Product from "../Components/product/Product";
import Quarries from "../Components/quarries/Quarries";
import Slider from "../Components/common/Slider";
import TopBar from "../Components/common/TopBar";
import SEO from "../Components/common/SEO";
import seoData from "../data/seoData.json";

function HomePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = seoData[currentLang]?.home || seoData.en.home;
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MOCA Mermer",
    "url": "https://mocamermer.com",
    "logo": "https://mocamermer.com/images/moca-mermer-logo.jpg",
    "description": seo.description,
    "foundingDate": "1975",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "TR",
      "addressRegion": "Antalya",
      "addressLocality": "Elmalı"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["Turkish", "English"]
    }
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/"
        structuredData={structuredData}
      />
      <TopBar />
      <Slider />
      <About />
      <Quarries />
      <Product />
      <Contact />
    </>
  );
}

export default HomePage;